import { autoChooseProps, getId } from '@common/utils/brandDiffsUtils';
import { GoogleMap, MarkerF, MarkerClusterer } from '@react-google-maps/api';
import { StoreLocatorActionTypes } from '@state/features/common.types';
import { setCenter, setCurrentStore, setOpenClusterDetail, setZoom } from '@state/features/storelocator.slice';
import analytics from '@utils/analytics';
import { debounce } from '@utils/functions';
import maputils from '@utils/maputils';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
const StoreLocatorMap = (props) => {
    // TODO needs some performance improvements, too many re-renders causing map lag
    const reRendersCount = useRef(0);
    reRendersCount.current++;
    console.info('StoreLocatorMap re-render: ', reRendersCount.current);
    const dispatch = useDispatch();
    const { stores, filteredStores, currentStore, zoom, center, updatedMapBounds, updateFromLocation } = props;
    const initialZoom = useRef(zoom).current;
    const initialCenter = useRef(center).current;
    const [map, setMap] = useState();
    const [isOver, setIsOver] = useState(false);
    const [markerOvered, setMarkerOvered] = useState(null);
    useEffect(() => {
        if (updatedMapBounds && map) {
            const currentBounds = map.getBounds();
            if (!currentBounds.equals(updatedMapBounds)) {
                console.info('mapBounds updated', updatedMapBounds);
                map.fitBounds(updatedMapBounds);
            }
        }
    }, [updatedMapBounds, map]);
    useEffect(() => {
        if (updateFromLocation && map) {
            console.info('setting current location on map');
            map.setCenter(updateFromLocation);
            // 12 come valore di zoom mi sembra abbastanza ampio
            map.setZoom(12);
        }
    }, [updateFromLocation, map]);
    const fitToStores = () => {
        var _a;
        console.info('eseguo fitToStores');
        let bounds = new google.maps.LatLngBounds();
        (_a = (filteredStores ? filteredStores : stores)) === null || _a === void 0 ? void 0 : _a.forEach((store) => {
            bounds.extend({ lat: store.latitude, lng: store.longitude });
        });
        map.fitBounds(bounds);
    };
    useEffect(() => {
        // for nearbystores
        if (map && props.localMap && !currentStore) {
            fitToStores();
        }
    }, [map, props.localMap]);
    useEffect(() => {
        if (map) {
            // se non ho zoom e center sono appena atterrato, calcolo fitToStores
            if ((filteredStores === null || filteredStores === void 0 ? void 0 : filteredStores.length) && (!zoom || !center))
                fitToStores();
        }
    }, [map, filteredStores]);
    useEffect(() => {
        if (map && currentStore) {
            console.info('[StoreLocatorMap] updated currentStore', currentStore);
            map.setZoom(18);
            map.setCenter(new google.maps.LatLng(currentStore.latitude, currentStore.longitude));
        }
    }, [map, currentStore]);
    const markerStyle = useMemo(() => [
        autoChooseProps({
            MO: {
                anchorText: [-9, 0],
                height: 50,
                width: 30,
                url: props.mapcluster,
            },
            ST: {
                textColor: 'white',
                fontFamily: `"MonumentGroteskMono", Arial, sans-serif;`,
                fontSize: 14,
                fontWeight: 500,
                height: 40,
                width: 40,
                url: props.mapcluster,
            },
        }),
    ], []);
    const delayedZoomChanged = useCallback(debounce(() => {
        if (map) {
            !props.localMap && dispatch(setZoom(map.getZoom()));
        }
    }, 500), [map]);
    const delayedCenterChanged = useCallback(debounce(() => {
        if (map) {
            !props.localMap && dispatch(setCenter(map.getCenter().toJSON()));
        }
    }, 500), [map]);
    const delayedBoundsChanged = useCallback(debounce(() => {
        if (map) {
            const bounds = map.getBounds();
            bounds && !props.localMap && dispatch({ type: StoreLocatorActionTypes.UPDATE_BOUNDS, payload: { newBounds: bounds.toJSON() } });
        }
    }, 500), [map]);
    const handleClusterClick = (cluster) => {
        setIsOver(false);
        // console.info('filteredStores: ', filteredStores);
        // console.info('cluster: ', cluster);
        if (cluster.markerClusterer.clusters.length == 1 && filteredStores.length == cluster.markerClusterer.clusters[0].markers.length) {
            // console.info('Store Locator - DepARTMENT store corners overlay');
            dispatch(setOpenClusterDetail(true));
            dispatch(setCurrentStore(undefined));
        }
    };
    const renderMarkerCluster = () => {
        return (React.createElement(MarkerClusterer, { averageCenter: true, styles: markerStyle, onClick: handleClusterClick }, (clusterer) => (filteredStores || stores).map((store, i) => (React.createElement(MarkerF, { key: store.ID, opacity: currentStore && currentStore.ID != store.ID ? 0.2 : 1, clusterer: clusterer, position: { lat: store.latitude, lng: store.longitude }, visible: filteredStores === null || filteredStores === void 0 ? void 0 : filteredStores.includes(store), onClick: () => {
                if (props.localMap) {
                    props.setCurrentStore && props.setCurrentStore(store.ID);
                }
                else {
                    dispatch(setOpenClusterDetail(false));
                    dispatch(setCurrentStore(store.ID));
                    analytics.storelocatorSelect(store.name);
                }
            }, icon: (currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID) === store.ID ? (props.mapmarker || '').replace('.svg', '-selected.svg') : props.mapmarker })))));
    };
    const handleClusterHover = (type, cluster) => {
        cluster.clusterIcon.div.className = type === 'over' ? 'cluster cluster--hover' : 'cluster';
        if (type === 'over') {
            setIsOver(true);
        }
        else if ('out') {
            setIsOver(false);
        }
    };
    const handleMarkerOver = (type, markerId) => {
        if (type === 'over') {
            setIsOver(true);
            setMarkerOvered(markerId);
        }
        else if ('out') {
            setIsOver(false);
            setMarkerOvered(null);
        }
    };
    const checkMarkerOver = (id) => getId() === 'ST' && markerOvered !== id && isOver;
    return ((stores === null || stores === void 0 ? void 0 : stores.length) > 0 && (React.createElement("div", { className: "store-locator__map", "data-marker-over": isOver },
        React.createElement(GoogleMap, { mapContainerClassName: 'google-map', zoom: initialZoom, center: initialCenter, onLoad: (map) => {
                console.info('map loaded', map);
                setMap(map);
            }, onZoomChanged: delayedZoomChanged, onCenterChanged: delayedCenterChanged, onBoundsChanged: delayedBoundsChanged, options: {
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                minZoom: 2,
                styles: maputils.style[getId()],
                restriction: {
                    strictBounds: true,
                    latLngBounds: {
                        east: 180,
                        north: 85,
                        south: -85,
                        west: -180,
                    },
                },
            } },
            renderMarkerCluster(),
            React.createElement(MarkerClusterer, { averageCenter: true, styles: markerStyle, onClick: handleClusterClick, onMouseOver: (e) => !window.isMobile() && handleClusterHover('over', e), onMouseOut: (e) => !window.isMobile() && handleClusterHover('out', e) }, (clusterer) => (filteredStores || stores).map((store, i) => (React.createElement(MarkerF, { key: store.ID, opacity: currentStore && currentStore.ID != store.ID ? 0.2 : 1, clusterer: clusterer, position: { lat: store.latitude, lng: store.longitude }, visible: filteredStores === null || filteredStores === void 0 ? void 0 : filteredStores.includes(store), onMouseOver: () => handleMarkerOver('over', store.ID), onMouseOut: () => handleMarkerOver('out', store.ID), onClick: () => {
                    if (props.localMap) {
                        props.setCurrentStore && props.setCurrentStore(store.ID);
                    }
                    else {
                        dispatch(setOpenClusterDetail(false));
                        dispatch(setCurrentStore(store.ID));
                        analytics.storelocatorSelect(store.name);
                    }
                }, icon: (currentStore === null || currentStore === void 0 ? void 0 : currentStore.ID) === store.ID
                    ? (props.mapmarker || '').replace('.svg', '-selected.svg')
                    : checkMarkerOver(store.ID)
                        ? (props.mapmarker || '').replace('.svg', '-inverted.svg')
                        : props.mapmarker }))))))));
};
export default StoreLocatorMap;
